"use client";

import DotPattern from "../../components/landing/dot-pattern";
import { cn } from "../../lib/utils";
import { CalSetterHero } from "../../components/landing/cal-setter-hero";

export default function Page() {
  return (
    <div className="h-full w-full container flex flex-col  space-y-lg md:space-y-8 mx-auto px-lg sm:px-xl">
      <div className="h-full pb-24">
        <CalSetterHero />
        {/* <Clients /> */}
      </div>

      <DotPattern
        className={cn(
          "h-full",
          "mask-[radial-gradient(800px_circle_at_center,white,transparent)]",
          "-z-10"
        )}
      />
    </div>
  );
}
